import React, { useRef } from "react";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import Left from "../images/left-arrow.svg";
import Right from "../images/right-arrow.svg";
import Tasks from "../images/tasks.svg";
import ChessTimer from "../images/chess_timer.svg";
import Vastride from "../images/vastride.svg";
import Ridezz from "../images/ridezz.svg";
import RPS from "../images/rps.svg";
import Spotify from "../images/spotify.svg";
import TicTacToe from "../images/tic-tac-toe.svg";
import ToDo from "../images/todo.svg";

export default function Portfolio() {
  const myRef = useRef();
  const Item = ({ img, title, id, btn, link }) => {
    return (
      <div className="item">
        <div className="item-comp">
          <div className="item-mask">
            <a href={link} target="_blank" rel="noopener noreferrer">
              <button>{btn}</button>
            </a>
          </div>
          <img id={id} src={img} alt="" />
        </div>
        <p>{title}</p>
      </div>
    );
  };

  return (
    <div id="section4" className="portfolio">
      <div className="portfolio-title">
        <h2>Portfolio</h2>
        <p> - Have a look on my portfolio projects -</p>
      </div>

      <div className="portfolio-carousel">
        <img
          onClick={() => {
            myRef.current.slidePrev();
          }}
          id="left"
          src={Left}
          alt=""
        />
        <AliceCarousel
          ref={myRef}
          mouseTracking={true}
          disableButtonsControls={true}
          disableDotsControls={true}
          infinite={true}
          responsive={{
            0: { items: 1 },
            800: { items: 2 },
            1024: { items: 3 },
          }}
        >
          <Item
            id={"i1"}
            link={
              "https://firebasestorage.googleapis.com/v0/b/ug-portfolio.appspot.com/o/Tasks.apk?alt=media&token=f092f95e-83ef-40be-a0be-08b983af9d1a"
            }
            btn={"Download"}
            img={Tasks}
            title={"Tasks - Todo App"}
          />
          <Item
            id={"i2"}
            link={
              "https://firebasestorage.googleapis.com/v0/b/ug-portfolio.appspot.com/o/Chess%20Timer.apk?alt=media&token=776d5713-a8d3-4d5d-87a6-9256974cff12"
            }
            btn={"Download"}
            img={ChessTimer}
            title={"Chess Timer"}
          />
          <Item
            id={"i3"}
            link={"http://vastride.com/"}
            btn={"visit site"}
            img={Vastride}
            title={"Vastride"}
          />
          <Item
            id={"i4"}
            link={
              "https://firebasestorage.googleapis.com/v0/b/ug-portfolio.appspot.com/o/Ridezz.apk?alt=media&token=1df99d70-a6a6-4e19-8246-0b0a0377ce3d"
            }
            btn={"Download"}
            img={Ridezz}
            title={"Ridezz"}
          />
          <Item
            id={"i5"}
            link={"https://ugs-rps-game.web.app/offline.html"}
            btn={"visit site"}
            img={RPS}
            title={"RPS Game"}
          />
          <Item
            id={"i6"}
            link={"https://ugs-spotify-clone.web.app/"}
            btn={"visit site"}
            img={Spotify}
            title={"Spotify Clone"}
          />
          <Item
            id={"i7"}
            link={"https://ugs-game.web.app/ai.html"}
            btn={"visit site"}
            img={TicTacToe}
            title={"Tic Tac Toe Game"}
          />
          <Item
            id={"i8"}
            link={"https://ugs-todo-app.web.app/"}
            btn={"visit site"}
            img={ToDo}
            title={"UG's ToDo"}
          />
        </AliceCarousel>
        <img
          onClick={() => {
            myRef.current.slideNext();
          }}
          id="right"
          src={Right}
          alt=""
        />
      </div>
    </div>
  );
}
